// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import qs from 'qs'
import less from 'less'
import BaiduMap from 'vue-baidu-map' //Map控件

import '../static/css/base.css'

Vue.use(Vuex)

Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.use(less)
Vue.use(BaiduMap, {
  ak: 'KcVcpVL1oMFi3sLA03jUvnAfUrQzSBVQ'  //密钥
})

Vue.config.productionTip = false

//请求地址总端口
axios.defaults.baseURL = 'http://super.jagich.com/api/';
//请求延时时间
// axios.defaults.withCredentials = true;
// axios.defaults.timeout = 5000;

//同一个项目的所有请求添加请求头
axios.interceptors.request.use((config) => {
  config.headers.token = localStorage.getItem('token');
	return config;
});
//响应回来token是否过期
axios.interceptors.response.use((response) => {
  if (response.data.code == 401) {
      localStorage.removeItem('token');
      router.push({ name: 'Login' });
      router.go(0);
      ElementUI.Message({
        message: '身份已失效，请重新登陆！',
        offset: 150,
        type:'warning'
      })
  }else {
      return response;
    }
}, (error) => {
    return Promise.reject(error);
})

// 判断公司信息字段是否为空，如果为空则强制停留在公司信息页面--此功能暂时屏蔽
// router.beforeEach((to, from, next) => {
//   //获取token
// 	const tokens = window.localStorage.getItem("token");
// 	//判断公司信息字段是否为空
//   axios.post("Myinfo/index", {
//     token: tokens,
//   }).then((res) => {
//     if (res.data.data.linkman == "") {
//       return next('/Personal');
//     } else if (res.data.data.phone == "") {
//       return next('/Personal');
//     } else if (res.data.data.email == "") {
//        return next('/Personal');
//     } else if (res.data.data.crop_name == "") {
//       return next('/Personal');
//     }
//   }).catch((err) => {
//     console.log(err);
//   })
// 	next();
// });
// export default router;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js